/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromAggregate1 from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import CloseAction from './CloseAction/index'
import CommsThread from 'DesignSystem/CommsThread/index'
import MoveAction from './MoveAction/index'
import React from 'react'
import WithBackdrop from 'DesignSystem/WithBackdrop/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Actions/EditLetterAction/Comms/Content"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let selectedCommsIsBlockingValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.is_blocking',
})
let selectedCommsDockedLeftValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.docked_left',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let patientPersonValueData = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.patientName,
})
let constantData = '- Patient'
let aggregateData = fromAggregate.join(patientPersonValueData, constantData)
let selectedCommsThreadIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.thread_id',
})
let selectedCommsIsSecureValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.is_secure',
})
let selectedCommsAutoUploadedAttachmentsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.auto_uploaded_attachments',
})
let selectedCommsMessageValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.message',
})
let selectedCommsTagsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.tags',
})
let constantData1 = 'Please find the attachments included for'
let patientPersonValueData1 = fromData.useDataFormat({ viewPath,
context: 'patient',
path: 'person',
format: fromFormat.patientName,
})
let aggregateData1 = fromAggregate1.join(constantData1, patientPersonValueData1)
let selectedCommsMessageComposesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.message_composes',
})
let selectedCommsThreadIdsHackValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'comms.thread_ids_hack',
})
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let onThreadIdsHackChange = fromHelpers.useOnThreadIdsHackChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<WithBackdrop
  viewPath={`${viewPath}/WithBackdrop`}
 data="selected.comms.is_blocking"
 isVisible={selectedCommsIsBlockingValueData}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--b-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--o-7-Z1Yf8zk': isBefore ? 0 : 1,'--ty-8-Z1Yf8zk': isBefore ? "-8px" : "0px",'--r-10-Z1Yf8zk': selectedCommsDockedLeftValueData ? "auto" : isMedia.mobile ? "0px" : typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--l-11-Z1Yf8zk': selectedCommsDockedLeftValueData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "auto",'--w-12-Z1Yf8zk': isMedia.mobile ? "100%" : "500px"}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<MoveAction
  viewPath={`${viewPath}/MoveAction`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
<CommsThread
  viewPath={`${viewPath}/CommsThread`}
 data="patient.person"
 format="/Data/format.js patientName"
 data="'- Patient'"
 aggregate="/Data/aggregate.js join"
 thread_name={aggregateData}
 data="selected.comms.thread_id"
 thread_id={selectedCommsThreadIdValueData}
 data="selected.comms.is_secure"
 is_secure={selectedCommsIsSecureValueData}
 data="selected.comms.auto_uploaded_attachments"
 auto_uploaded_attachments={selectedCommsAutoUploadedAttachmentsValueData}
 data="selected.comms.message"
 message={selectedCommsMessageValueData}
 data="selected.comms.tags"
 tags={selectedCommsTagsValueData}
 data="'Please find the attachments included for'"
 data="patient.person"
 format="/Data/format.js patientName"
 aggregate="/Simple/Data/aggregate.js join"
 attachments_message={aggregateData1}
 onSubmit={onSubmit}
 data="selected.comms.message_composes"
 message_composes={selectedCommsMessageComposesValueData}
 data="selected.comms.thread_ids_hack"
 thread_ids_hack={selectedCommsThreadIdsHackValueData}
 onChange={onChange}
 onThreadIdsHackChange={onThreadIdsHackChange}
 data="patient._id"
 patient_id={patientIdValueData}
/>
</div>
)}
</WithBackdrop>
{children}
</React.Fragment>)
}